export enum AlertFrequency {
  Days,
  Weeks,
  Months,
  EndOfProgram
}
